import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore } from 'redux-persist';

import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import { history } from './utils/router';
//import { persistStore } from 'redux-persist';
import { apiMiddleware, offlineEffect } from './api';
import rootReducer from './reducers';
import { offline } from '@redux-offline/redux-offline';
import defaultConfig from '@redux-offline/redux-offline/lib/defaults';

const router = routerMiddleware(history);
const offlineConfig = {
  ...defaultConfig,
  effect: offlineEffect,
  persist: null,
};

function tickMiddleware(store) {
  return next => action => {
    if (action.type === 'Offline/SCHEDULE_RETRY') {
      const intervalId = setInterval(() => {
        store.dispatch({ type: 'TICK' });
      }, 1000);
      setTimeout(() => clearInterval(intervalId), action.payload.delay);
    }
    return next(action);
  };
}

const configureStore = () => {
  const middlewares = [thunk, router, apiMiddleware, tickMiddleware];

  let store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
      window.__REDUX_DEVTOOLS_EXTENSION__(),
    compose(applyMiddleware(...middlewares), offline(offlineConfig))
  );
  let persistor = persistStore(store);
  return { store, persistor };
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/configureStore.js